import { ReportIssuePage } from ".";
import { MenuRoute } from "../../components/menu";
import { ShellRouteNames } from "../shell/route-names";

const names = {
  index: `${ShellRouteNames.shell}.report-issue`,
};

const states: MenuRoute[] = [
  {
    name: names.index,
    component: ReportIssuePage,
    url: "/report-issue",
    data: {
      title: "report-an-issue",
    },
  },
];

export const ReportIssueRoutes = {
  names,
  states,
};
